import Transformer from './../transformer'
import materials from '@/transformers/purchase/materials'
import { assetURL } from '@/utils'

export default class QuotationTransformer extends Transformer {
  static fetch(quotation) {
    return {
      // Data
      materials: materials.fetchCollection(quotation.materials),
      id: quotation.id,
      /* cambiar camp > highway PURCHASE 2 */
      camp: quotation.camp,
      deliveryConditions: quotation.delivery_conditions,
      deliveryDays: quotation.expected_delivery_days,
      folio: quotation.folio,
      groupingSheet: quotation.grouping_sheet,
      isActive: quotation.is_active,
      paymentCnditions: quotation.payment_conditions,
      requestFile: assetURL(quotation.request_file),
      responseFile: assetURL(quotation.response_file),
      userWhoRequested: quotation.user_who_requested,
      status: quotation.status,
      // Provider -> Object
      providerId: quotation.provider.id,
      providerName: quotation.provider.name,
      providerNumber: quotation.provider.provider_number,
      providercommercialName: quotation.provider.commercial_name,
      providerStatus: quotation.provider.status,
      // Requisitions -> List of Array
      requisitions: quotation.requisitions,
      // front
      totalPurchase: false,
      validateField: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/purchase/quotationRequisition.js